import { Injectable } from '@angular/core';
import { PanelActions } from "@store/doc-viewer/panel/panel.actions";
import { Store } from "@ngrx/store";
import { of, switchMap, withLatestFrom } from "rxjs";
import { allPanelStates } from "@store/doc-viewer/panel/panel.selectors";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { PanelState } from "@store/doc-viewer/panel/panel-state";
import { DocViewerActions } from "@store/doc-viewer/doc-viewer.actions";

@Injectable()
export class PanelEffects {
	public savePanelStates$ = createEffect(() => this.actions$.pipe(
			ofType(PanelActions.expandPanel, PanelActions.collapsePanel),
			withLatestFrom(this.store.select(allPanelStates())),
			switchMap(([, panelStates]) => {
				if (panelStates) {
					localStorage.setItem('panelStates', JSON.stringify(panelStates));
				}
				return of({type: 'noop'})
			})
		)
	);

	public loadPanelStates$ = createEffect(() => this.actions$.pipe(
			ofType(DocViewerActions.loaded),
			switchMap(() => {
				const panelStates: Record<string, PanelState> = JSON.parse(localStorage.getItem('panelStates'));
				if (!panelStates) {
					return of({type: 'noop'});
				}
				return of(PanelActions.setPanelStates({panelStates}));

			})
		)
	);

	constructor(
		private actions$: Actions,
		private store: Store
	) {
	}
}
